<template>
    <div class="center flex">
        <div class="flex1">
            <router-link to="/user/rank">
                <div class="button">
                    {{ rankText }}：<span>{{ ownRank.ranking ? ownRank.ranking : `${ownRank.overRanking}+` }}
                    </span>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
  props: ['rank', 'rankText', 'ownRank'],
  name: 'Rank',
}
</script>
<style lang="scss" scoped>
.button{
    display: inline-block;
    margin: 0;
    margin-top:0.17rem;
    width: auto;
    padding: 0 .15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userElement/Rank.vue